// extracted by mini-css-extract-plugin
export default {"wrapper":"ReservationCircles_wrapper__9V+8N","circle":"ReservationCircles_circle__dmyDf","pink":"ReservationCircles_pink__J8tlw","blue":"ReservationCircles_blue__LXhQa"};